import { http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { Batch } from './batch.interface';
import { ApiResource } from '../../models/api-resource.interface';

export class BatchService {
   async getBatch(batchId: number) {
      const response = await http.get<Batch>(`/batches/${batchId}`);
      return response.data;
   }
   async getBatches(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<Batch>>>(`/batches`, { params: { ...query } });
      return response.data;
   }
}
